<template>

    <article>
        <a :href="resource.url">
            <div class="blogList-block-item-img">
                <figure>
                    <picture loading="lazy">
                        <img v-if="resource.resourceImage" :src="resource.resourceImage" loading="lazy" />
                    </picture>
                </figure>
                <span class="blogList-block-item-category">{{ resource.category }}</span>
            </div>
            <div class="blogList-block-item-text bg-blue-light">
                <p class="blogList-block-item-date">{{ resource.postDate|date("jS F Y") }}</p>
                <h3>{{ resource.title }}</h3>
                <span>Read the article</span>
            </div>
        </a>
    </article>

</template>

<script>
    export default {
        props: {
            resource: Object
        },
        methods: {
            
        }
    }
</script>
